<template>
    <div
        class="calc-cell"
        :class="[
            kind === 'string' ? 'text-left' : 'text-center justify-center',
            fill ? 'fill' : '',
        ]"
    >
        <template v-if="active">
            <span v-if="kind === 'price'" class="mr-1">{{
                currency || 'USD'
            }}</span>
            <input
                ref="input"
                v-model="draft"
                :type="kind === 'string' ? 'text' : 'number'"
                step="any"
                class="calc-cell-input mr-2"
                :style="
                    fill
                        ? null
                        : inputWidth
                        ? { width: inputWidth }
                        : kind === 'string'
                        ? 'width: 10rem'
                        : 'width: 5.5rem'
                "
                @keyup.enter="commit"
            />
            <v-btn
                icon
                x-small
                color="success"
                :loading="saving"
                @click="commit"
            >
                <v-icon small>mdi-check</v-icon>
            </v-btn>
            <v-btn
                icon
                x-small
                color="error"
                :disabled="saving"
                @click="$emit('cancel')"
            >
                <v-icon small>mdi-close</v-icon>
            </v-btn>
        </template>
        <template v-else>
            <span class="mr-2">{{ displayText }}</span>
            <v-btn
                v-if="canEdit"
                icon
                x-small
                color="primary"
                @click="$emit('edit')"
            >
                <v-icon small>mdi-pencil</v-icon>
            </v-btn>
        </template>
    </div>
</template>

<script>
export default {
    name: 'CalculatorItemEditableCell',
    props: {
        item: { type: Object, required: true },
        field: { type: String, required: true },
        kind: { type: String, default: 'number' },
        canEdit: Boolean,
        editingId: String,
        editingField: String,
        editingValue: [String, Number],
        saving: Boolean,
        displayText: String,
        currency: String,
        inputWidth: { type: String, default: '' },
        fill: Boolean,
    },
    data() {
        return { draft: '' }
    },
    computed: {
        active() {
            return (
                this.editingId === this.item.id &&
                this.editingField === this.field
            )
        },
    },
    watch: {
        active(val) {
            if (!val) return
            this.draft = this.editingValue != null ? this.editingValue : ''
            this.$nextTick(() => {
                if (this.$refs.input) this.$refs.input.focus()
            })
        },
    },
    methods: {
        commit() {
            this.$emit('save', this.draft)
        },
    },
}
</script>

<style scoped>
.calc-cell {
    display: flex;
    align-items: center;
    white-space: nowrap;
}
.calc-cell.fill {
    width: 100%;
}
.calc-cell-input {
    flex: 0 0 auto;
    height: 28px;
    padding: 0 6px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    outline: none;
    font: inherit;
    background: transparent;
}
.calc-cell.fill .calc-cell-input {
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
}
</style>
